module.exports = __webpack_public_path__ + "Titillium-Regular.90a961b1bbe9af9311e7.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Titillium-Regular.otf
// module id = 377
// module chunks = 8